<template lang="pug">
  header.header(v-if="header" :class="{'header--hide': hideHeader}")
    .page__wr
      .header__content
        .header__top
          .header__top-left
            router-link.header__logo-lnk(to="/" :class="{'no-visible': mainPage}")
              img.header__logo-img(src="@/assets/img/logo.svg" alt="Nebo")
            .header__avax
              a.header__avax-lnk(target="_blank" href="http://avaxhotel.ru/" v-on:click="openInNewTab($event)")
                img.header__avax-logo(src="@/assets/img/avax.svg" alt="Avax")
              p.header__avax-text Официальный ресторан отеля AVAX
          .header__top-right
            .header__top-address
              .header__top-address-left
                SvgIcon(class='header__top-ico-address' name="placeholder" width="20" height="29")
              .header__top-address-right
                | {{header.headerTop.address}}
            .header__top-phone
              .header__top-phone-left
                SvgIcon(class='header__top-ico-phone' name="phone" width="21" height="21")
              .header__top-phone-right
                a.header__top-phone-lnk(:href='"tel:" + header.headerTop.phone')
                  | {{header.headerTop.phone}}
        .header__bottom
          MenuTop(:items="menuTop")
          HiddenMenu(:items="menuTop")
</template>

<script>

  import EventBus from '@/eventBus';

  import MenuTop from '@/components/common/menuTop/menuTop.vue';
  import HiddenMenu from '@/components/common/hiddenMenu/HiddenMenu.vue';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

  export default {
    name: 'Header',

    components: {
      MenuTop,
      HiddenMenu,
      SvgIcon
    },

    data() {
      return {
        header: null,
        menuTop: [],
        mainPage: false,
        hideHeader: false,
        firstLoad: false,
        path: '',
      }
    },

    created() {
      // Данные страницы загружены
      EventBus.$on('pageLoaded', (res) => {
        this.header = res.header;
        this.menuTop = res.menuTop;
        if (this.firstLoad === true && this.path === '/') {
            this.hideHeader = true;
            this.firstLoad = false;
            setTimeout(() => {
                this.hideHeader = false;
            }, 500);
        }
      });
      EventBus.$on('firstLoad', url => {
          this.firstLoad = true;
          this.path = url;
          this.hideLogo(url);
      });
      EventBus.$on('routeUpdate', (url) => {
          this.hideLogo(url);
      });
    },
    methods: {
      openInNewTab (event) {
          let element = event.target;
          window.open(element.href ,'_blank');
      },
      hideLogo(url) {
        if (url === '/') {
            this.mainPage = true;
        }
        else {
            this.mainPage = false;
        }
      }
    }
  }
</script>
